<template>
  <div>
    <h1>Editar Oportunidade</h1>
    <b-card>
      <Form @saved="loadData" />
    </b-card>
  </div>
</template>

<script>
import Form from "../Components/Form.vue";
import { mapState, mapActions } from "vuex";

export default {
  components: { Form },
  computed: {
    ...mapState("oportunidades", ["oportunidade"]),
  },
  methods: {
    ...mapActions("oportunidades", ["ActionNewOportunidade", "ActionShow"]),
    async loadData(id) {
      try {
        await this.ActionShow(id);
      } catch (error) {
        this.$notifications.addNotification({
          message: error.data.responseMessage,
          icon: "exclamation-triangle",
          type: "danger",
        });
        this.$router.push({ name: "oportunidades_list" });
      }
    },
  },
  async created() {
    this.ActionNewOportunidade();
    await this.loadData(this.$route.params.id);
  },
};
</script>

<style></style>
